import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { notificationService } from '@/api/services/notificationService'

export function useNotifications(p?: Parameters<typeof notificationService.list>[0]) {
  return useQuery({ queryKey: ['notifications', p], queryFn: () => notificationService.list(p), staleTime: 30_000 })
}

export function useSendNotification() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: Parameters<typeof notificationService.send>[0]) => notificationService.send(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  })
}
